import { Plugin } from 'ckeditor5'

// Convert paragraph padding-left to margin-left to maintain compatibility with legacy editor output
export class IndentPaddingToMarginPlugin extends Plugin {
  static get pluginName() {
    return 'IndentPaddingToMargin'
  }

  init() {
    const editor = this.editor
    const originalToView = editor.data.processor.toView.bind(
      editor.data.processor
    )
    editor.data.processor.toView = (data: string) => {
      const convertedData = data.replace(
        /<p([^>]*style="[^"]*?)padding-left:\s*([^;]+)(;?)([^"]*"[^>]*>)/gi,
        '<p$1margin-left: $2$3$4'
      )
      return originalToView(convertedData)
    }
  }
}
